import React from 'react'

export default function ConfettiIcon({ size = 73, className = '' }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 73 73"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M46.5328 48.3088C46.0828 48.7588 44.8735 48.3707 43.1916 47.3525C40.7503 45.8732 37.3191 43.0663 33.8035 39.5563C30.2878 36.0463 27.4922 32.6151 26.0128 30.1738C25.0003 28.4863 24.6066 27.2825 25.0566 26.8325C26.1816 25.7075 31.8516 29.6451 37.786 35.5851C43.7203 41.5251 47.6353 47.2119 46.5328 48.3088Z"
        fill="#FE852B"
      />
      <path
        d="M43.1924 47.3506C40.7512 45.8712 37.3199 43.0644 33.8043 39.5544C30.2887 36.0444 27.493 32.6131 26.0137 30.1719C28.4605 31.6513 31.8862 34.4525 35.3962 37.9681C38.9062 41.4837 41.713 44.9037 43.1924 47.3506Z"
        fill="#D46F24"
      />
      <path
        d="M46.2352 48.465L41.3246 51.0188L37.2183 53.1563L34.5071 54.5681L30.5077 56.6494L27.7964 58.0669L23.9096 60.0919L21.2152 61.4925L17.3902 63.4669L14.7183 64.8563L10.9664 66.8419L10.5783 67.0444C9.93153 67.38 9.19505 67.5021 8.47456 67.3931C7.9249 67.315 7.40248 67.1044 6.95228 66.7795C6.50207 66.4546 6.13758 66.0252 5.89018 65.5281C5.64277 65.0311 5.51988 64.4814 5.53208 63.9264C5.54427 63.3713 5.69119 62.8275 5.96019 62.3419L6.17394 61.9369L8.21019 58.2244L9.62206 55.5919L11.6696 51.7838L13.1039 49.1175L15.1908 45.225L16.6477 42.5306L18.7852 38.5538L20.1971 35.9044L22.3908 31.8263L24.9052 27.1406C24.4946 28.7213 28.2802 34.0481 33.8096 39.5831C39.3389 45.1181 44.6377 48.8419 46.2352 48.465Z"
        fill="#FE9F59"
      />
      <path
        d="M34.5125 54.5686L30.5131 56.6498C26.9918 54.2141 23.7806 51.358 20.9506 48.1448C19.3844 46.3688 17.9393 44.4896 16.625 42.5198L18.7625 38.543C22.6999 45.03 28.0919 50.5126 34.5125 54.5573V54.5686Z"
        fill="#A54FE7"
      />
      <path
        d="M27.8073 58.0667L23.9091 60.0917C21.6485 58.3899 19.5285 56.5088 17.5698 54.4667C15.9638 52.7868 14.4718 51.0016 13.1035 49.123L15.1904 45.2305C16.5043 47.1868 17.9575 49.046 19.5385 50.7936C22.0115 53.5222 24.7854 55.9622 27.8073 58.0667Z"
        fill="#A54FE7"
      />
      <path
        d="M21.2098 61.4939L17.3904 63.4683C16.2992 62.5683 15.2473 61.6308 14.2348 60.6558C12.5911 59.0699 11.0522 57.3789 9.62793 55.5933L11.6754 51.7852C14.3979 55.4553 17.616 58.7302 21.2379 61.5164L21.2098 61.4939Z"
        fill="#A54FE7"
      />
      <path
        d="M14.7179 64.8809L10.9661 66.8441L10.9323 66.8103C9.24496 65.306 7.66075 63.6898 6.19043 61.9728L8.2098 58.2266C9.63904 60.0006 11.1937 61.6699 12.8617 63.2216C13.4636 63.7953 14.0767 64.3466 14.7179 64.8809Z"
        fill="#A54FE7"
      />
      <path
        d="M41.3304 51.0206L37.2241 53.1581C32.3489 50.0922 28.0074 46.2503 24.371 41.7844C22.8482 39.9219 21.4537 37.958 20.1973 35.9062L22.391 31.8281C23.5711 33.9881 24.9117 36.0565 26.4016 38.0156C30.4413 43.3211 35.5212 47.7464 41.3304 51.0206Z"
        fill="#A54FE7"
      />
      <path
        d="M12.8564 63.2188C13.4582 63.7812 14.077 64.3438 14.7126 64.8781L10.9664 66.8413L10.9326 66.8075L10.9664 66.7456L12.8564 63.2188Z"
        fill="#9831E7"
      />
      <path
        d="M16.1806 57.0312C17.7501 58.6343 19.4306 60.1248 21.2094 61.4919L17.39 63.4663C16.2988 62.5663 15.2469 61.6288 14.2344 60.6538L14.4031 60.3444L16.1806 57.0312Z"
        fill="#9831E7"
      />
      <path
        d="M27.8078 58.0666L23.9097 60.0916C21.6491 58.3897 19.5291 56.5086 17.5703 54.4666L17.8741 53.9041L19.5334 50.8047C22.0088 53.5297 24.7846 55.9659 27.8078 58.0666Z"
        fill="#9831E7"
      />
      <path
        d="M34.513 54.5677L30.5137 56.6489C26.9923 54.2132 23.7811 51.3571 20.9512 48.1439L21.4012 47.3058L22.9537 44.4258C26.2463 48.3963 30.1479 51.8195 34.513 54.5677Z"
        fill="#9831E7"
      />
      <path
        d="M41.3305 51.0197L37.2242 53.1572C32.349 50.0912 28.0075 46.2494 24.3711 41.7834L24.973 40.6584L26.4073 37.9922C30.4431 43.3052 35.5212 47.7382 41.3305 51.0197Z"
        fill="#9831E7"
      />
      <path
        d="M43.3662 36.7474C43.3662 36.7474 50.9318 22.3699 59.1162 26.6224C66.9125 30.6724 62.1087 37.1412 62.1087 37.1412"
        stroke="#9831E7"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.304 29.4372C38.304 29.4372 50.9209 23.4354 46.6684 15.2454C42.6184 7.4491 36.1553 12.281 36.1553 12.281"
        stroke="#9831E7"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.6162 37.3125L56.585 16.7812C57.9273 15.4384 58.6814 13.6175 58.6814 11.7188C58.6814 9.82004 57.9273 7.99906 56.585 6.65625"
        stroke="#9831E7"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.1787 15.9922L28.7862 17.2241L30.1475 17.4209L29.1631 18.3828L29.3937 19.7384L28.1787 19.0972L26.9637 19.7384L27.1943 18.3828L26.21 17.4209L27.5712 17.2241L28.1787 15.9922Z"
        fill="#FE9F59"
      />
      <path
        d="M52.3557 4.54594L52.1138 5.90156L53.0869 6.86906L51.7257 7.05469L51.1069 8.28094L50.505 7.04344L49.1494 6.83531L50.145 5.88469L49.9257 4.52344L51.135 5.17594L52.3557 4.54594Z"
        fill="#FE5959"
      />
      <path
        d="M56.8557 33.2391L56.6138 34.5891L57.5869 35.5566L56.2257 35.7422L55.6069 36.9684L55.005 35.7309L53.6494 35.5228L54.645 34.5722L54.4257 33.2109L55.635 33.8634L56.8557 33.2391Z"
        fill="#FE5959"
      />
      <path
        d="M45.8975 40.9664C45.8975 40.9664 55.7412 38.9977 56.3037 45.7477C56.8662 52.4977 50.3975 51.6539 50.3975 51.6539"
        stroke="#9831E7"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.1162 18.75C41.7375 18.75 42.2412 18.2463 42.2412 17.625C42.2412 17.0037 41.7375 16.5 41.1162 16.5C40.4949 16.5 39.9912 17.0037 39.9912 17.625C39.9912 18.2463 40.4949 18.75 41.1162 18.75Z"
        fill="#FE5959"
      />
      <path
        d="M61.085 24.6562C61.7063 24.6562 62.21 24.1526 62.21 23.5312C62.21 22.9099 61.7063 22.4062 61.085 22.4062C60.4636 22.4062 59.96 22.9099 59.96 23.5312C59.96 24.1526 60.4636 24.6562 61.085 24.6562Z"
        fill="#FE5959"
      />
      <path
        d="M62.7725 8.34375C63.3938 8.34375 63.8975 7.84007 63.8975 7.21875C63.8975 6.59743 63.3938 6.09375 62.7725 6.09375C62.1511 6.09375 61.6475 6.59743 61.6475 7.21875C61.6475 7.84007 62.1511 8.34375 62.7725 8.34375Z"
        fill="#A54FE7"
      />
    </svg>
  )
}
